import {
  DeadlineSettingsEditInterface,
  DeadlineSettingsInterface,
} from 'modules/funnels/funnel/types/deadline-settings-interface'
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum'

interface FunnelStepDataInterface {
  id: number
  caption: string
}

const availableFunnelStepTypes = [FunnelStepTypeEnum.OfferForm, FunnelStepTypeEnum.SalesPage]

export const getFunnelStepsToRedirectData = (funnelStepsList?: FunnelStepInterface[]) => {
  return (
    funnelStepsList?.reduce((acc, curr) => {
      if (curr.page) {
        acc.push({ id: curr.id, caption: curr.name })
      }
      return acc
    }, [] as FunnelStepDataInterface[]) || []
  )
}

export const getAvailableFunnelStepsData = (funnelStepsList?: FunnelStepInterface[]) => {
  return (
    funnelStepsList?.reduce((acc, curr) => {
      if (availableFunnelStepTypes.includes(curr.type)) {
        acc.push({ id: curr.id, caption: curr.name })
      }
      return acc
    }, [] as FunnelStepDataInterface[]) || []
  )
}

export const getDeadlineSettingsEditValues = (
  deadlineSettings: DeadlineSettingsInterface,
): DeadlineSettingsEditInterface => ({
  enabled: deadlineSettings.enabled,
  deadlinePageExpirationInDays: deadlineSettings.deadlinePageExpirationInDays ?? 0,
  expirationFunnelStep: deadlineSettings.expirationFunnelStep?.id,
  deadlineTime: deadlineSettings.deadlineTime,
  deadlineFunnelSteps: deadlineSettings.deadlineFunnelSteps.map(funnelStep => funnelStep.id),
})

const isSameFunnelStepsSelection = (current: number[], initial: number[]) =>
  current.length === initial.length && current.every(id => initial.includes(id))

// `deadlineTime` is compared separately, as the seconds the time picker holds: the timezone
// round-trip is not symmetrical across a day boundary, so the saved value and the value the
// picker was seeded with can differ without the user touching anything.
export const isDeadlineSettingsChanged = (
  current: DeadlineSettingsEditInterface,
  initial: DeadlineSettingsEditInterface,
  currentDeadlineSeconds: number | null,
  initialDeadlineSeconds: number | null,
) =>
  current.enabled !== initial.enabled ||
  current.deadlinePageExpirationInDays !== initial.deadlinePageExpirationInDays ||
  current.expirationFunnelStep !== initial.expirationFunnelStep ||
  currentDeadlineSeconds !== initialDeadlineSeconds ||
  !isSameFunnelStepsSelection(current.deadlineFunnelSteps, initial.deadlineFunnelSteps)
